import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import styled from 'styled-components';
import ControlWithLabel from './ControlWithLabel';

const { Group } = Radio;

const RadioButtons = ({
  value,
  onChange,
  options,
  label,
  className,
  disabled
}) => (
  <ControlWithLabel label={label} className={className}>
    <StyledRadioGroup
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
      size="small"
      options={options}
      optionType="button"
      buttonStyle="solid"
      disabled={disabled}
    />
  </ControlWithLabel>
);

const StyledRadioGroup = styled(Group)`
  &.ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    &::before {
      background-color: #21b4bd;
    }
    background: #21b4bd;
    border-color: #21b4bd;
  }

  .ant-radio-button-wrapper:hover {
    color: #21b4bd;
  }
`;

RadioButtons.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string
};

export default RadioButtons;
